export default __webpack_public_path__ + "static/salonImage-f6dd024f8c3b8ba59da73b9a2a4d6e03.jpg";